<!-- @format -->

@if (customStudyDraft(); as customStudyDraft) {
  <sis-study-box
    [type]="StudyBoxType.studyDraft"
    [id]="customStudyDraft.id"
    [name]="customStudyDraft.name"
    [credits]="{ min: customStudyDraft.credits, max: customStudyDraft.credits }"
    [level]="headingLevel()"
    (nameClickAction)="openCustomStudyDraftInfoModal(customStudyDraft)">
    @if (plannedPeriods(); as plannedPeriods) {
      <ng-container study-box="notifications">
        <app-timeline-multi-period-timing-notification-box [plannedPeriods]="plannedPeriods" [currentPeriod]="currentPeriod()" />
      </ng-container>
    }
  </sis-study-box>
}
